export default {
  POPUP: 'popup',
  OVERLAY: 'overlay',
};



// WEBPACK FOOTER //
// ./src/shared/constants/modal-types.js